/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { DelCustomerSummaryVO } from '@well/domain';
import { Maybe } from '@irian-ro/util-functions';
import { ShipmentDtoModel } from './shipment-dto.model';

export class ShipmentDraftDTO extends ShipmentDtoModel {

  customerVO: DelCustomerSummaryVO | undefined = undefined;

  requestingCompanyLeUuid: Maybe<string> | undefined = undefined;

  constructor() {
    super();
    this.customerVO = new DelCustomerSummaryVO();
  }
}

